// One-time language handoff for the native Shopify -> Recharge redirect.
// No customer identifiers, tokens or account data are stored.
(() => {
  if (!/^\/(?:en\/)?tools\/recurring\/portal\//.test(location.pathname)) return;
  try {
    const key = 'facts.account.language';
    const raw = sessionStorage.getItem(key);
    if (!raw) return;
    sessionStorage.removeItem(key); // Consume before navigation: never loop or override later choices.
    const intent = JSON.parse(raw);
    const age = Date.now() - intent.at;
    if (!['de','en'].includes(intent.locale) || !Number.isFinite(age) || age < 0 || age > 120000) return;
    const target = new URL(location.href);
    const unprefixed = target.pathname.replace(/^\/en\//, '/');
    target.pathname = (intent.locale === 'en' ? '/en' : '') + unprefixed;
    if (target.pathname !== location.pathname) location.replace(target.href);
  } catch {} // Native portal remains available if browser storage is unavailable.
})();
